import React, {useRef} from "react";
import {OverlayTrigger, Tooltip} from "react-bootstrap";

/**
 * Shows the lookthrough date in a different colour depending on its age
 */
export default function LookthroughDate(props) {
    let status = props.status;
    let dateFormatted = props.dateFormatted;

    const target = useRef(null);

    let lookthrough;
    const lookthroughFormatted = <span className={"nowrap"}>{dateFormatted}</span>;

    if (status && status !== 'ok') {

        lookthrough =
            <OverlayTrigger
                placement='auto'
                delay={{show: 500, hide: 0}}
                trigger={["hover", "focus"]}
                target={target}
                overlay={
                    <Tooltip id="tooltip-bottom">
                        {status === 'warning' ? 'Old lookthrough (> 3 months)' : 'Outdated lookthrough (> 6 months)'}
                    </Tooltip>
                }
                defaultShow={false}>
                {/*need to set display to prevent conflict between tr mouseover and tooltip*/}
                <span ref={target} style={{display: 'inline-block'}} className={'lookthrough-' + status}>
                    {lookthroughFormatted}
                </span>
            </OverlayTrigger>;
    } else {
        lookthrough = lookthroughFormatted
    }

    return lookthrough;
}
